// @ts-ignore
import styles from "./Badge.module.scss";
import clsx from "clsx";
import {_} from "i18n";
import {Keys} from "i18n/locales/types";
import React from "react";

interface BadgeProps {
	label: string;
	variant?: "default" | "primary" | "secondary" | "info" | "success" | "danger" | "warning";
	disabled?: boolean;
	outline?: boolean;
	size?: "lg" | "md" | "sm" | "xs";
	block?: boolean | undefined;
	icon?: string | undefined;
	iconPosition?: "left" | "right";
	onClick?: (event?: React.MouseEvent) => void;
	clickableOnDisabled?: boolean;
	className?: string;
}

export function Badge(props: BadgeProps) {
	const classNames = [styles.badge];

	classNames.push(styles[`badge-${props.size || "md"}`]);
	classNames.push(styles[`badge-${props.variant || "default"}`]);

	if (!!props.block) {
		classNames.push(styles[`badge-block`]);
	}
	if (!!props.outline) {
		classNames.push(styles[`badge-outline`]);
	}
	if (!!props.onClick && !props.disabled) {
		classNames.push(styles[`badge-clickable`]);
	}
	if (!!props.disabled) {
		classNames.push(styles.disabled);
	}
	if (props.icon) {
		classNames.push(styles[`badge--icon-${props.iconPosition || "left"}`]);
	}
	if (props.className) {
		classNames.push(props.className);
	}

	return (
		<span className={clsx(...classNames)} onClick={!props.disabled || props.clickableOnDisabled ? props.onClick : () => {}}>
			{props.icon && <span className={clsx("icon", `icon-${props.icon}`, styles[`badge__icon`])} />}
			<span className={styles[`badge__label`]}>{_(props.label as keyof Keys)}</span>
		</span>
	);
}
